import http from "./http.js";

async function getRate(today) {
  try {
    const response = await http.get(`base-rate/${today}`);
    return response.data.rate;
  } catch (err) {
    throw err;
  }
}

export { getRate };
